module.exports = __webpack_public_path__ + "img/door.a5fc0498.png";